import { forwardRef } from 'react';
import type { BusinessIconImageProps } from '../businessTypes';

type WidgetsFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const WidgetsFilled = forwardRef<SVGSVGElement, WidgetsFilledProps>(
  ({ size = 24, width, height, alt = '', color = 'currentColor', secondaryColor = '#fff', strokeWidth, style, ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={color}
      strokeWidth={strokeWidth}
      width={width ?? size}
      height={height ?? size}
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={{ color, ...style }}
      {...props}
    >
      <g transform="translate(-4.234188 -4.755474) scale(1.014632)">
        <path d="M26.6668 12.2903L23.4448 15.5122C22.5559 16.4027 21.1133 16.4027 20.2228 15.5122L17.0009 12.2903C16.112 11.3998 16.112 9.9588 17.0009 9.06831L20.2228 5.84634C21.1133 4.95747 22.5543 4.95747 23.4448 5.84634L26.6668 9.06831C27.5556 9.9588 27.5556 11.3998 26.6668 12.2903ZM18.6539 17.6737H23.7411C25.1464 17.6737 26.2847 18.8119 26.2847 20.2173V25.3044C26.2847 26.7098 25.1464 27.848 23.7411 27.848H18.6539C17.2486 27.848 16.1104 26.7098 16.1104 25.3044V20.2173C16.112 18.8119 17.2502 17.6737 18.6539 17.6737ZM12.2958 27.8464H7.21032C5.80496 27.8464 4.66675 26.7081 4.66675 25.3028V20.2156C4.66675 18.8119 5.80496 17.6737 7.21032 17.6737H12.2975C13.7012 17.6737 14.841 18.8119 14.841 20.2173V25.3044C14.8394 26.7081 13.7012 27.8464 12.2958 27.8464ZM12.2958 16.4011H7.21032C5.80496 16.4011 4.66675 15.2629 4.66675 13.8592V8.77201C4.66675 7.36666 5.80496 6.22844 7.21032 6.22844H12.2975C13.7012 6.22844 14.841 7.36666 14.841 8.77201V13.8592C14.8394 15.2629 13.7012 16.4011 12.2958 16.4011Z" />
      </g>
    </svg>
  ),
);

WidgetsFilled.displayName = 'WidgetsFilled';

export default WidgetsFilled;
